import type { Guide } from '../types/content'

export const featuredGuide: Guide = {
  slug: 'best-santa-barbara-beaches-with-kids',
  title: 'The 12 best Santa Barbara beaches with kids',
  deck:
    'Calm water, real bathrooms and shade that actually exists — ranked by how a beach day with a two-year-old truly goes.',
  category: 'Beaches',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/075d0515-fa19-4f92-8cdc-efc14cc79c1e.jpg',
  imageAlt:
    'A toddler crouching beside a shallow tidepool on a sunlit Santa Barbara beach',
  updated: 'Updated June 2026',
  readMinutes: 11,
  itemCount: 12,
  ages: ['0–2', '3–5', '6–9', '10+'],
  neighborhood: 'Countywide',
  cost: 'Free',
}

export const guides: Guide[] = [
  {
    slug: 'rainy-day-santa-barbara-with-kids',
    title: 'Rainy day in Santa Barbara: 18 indoor ideas',
    deck:
      'What we actually do when the marine layer never burns off — sorted by how long it buys you.',
    category: 'Rainy day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/28b63e03-f2f6-4ec7-a506-0140872dc6a9.jpg',
    imageAlt: 'Small hands stacking wooden blocks in a bright indoor play space',
    updated: 'Updated May 2026',
    readMinutes: 8,
    itemCount: 18,
    ages: ['0–2', '3–5', '6–9'],
    neighborhood: 'Countywide',
    cost: '$',
  },
  {
    slug: 'santa-barbara-summer-camp-guide',
    title: 'Summer camp guide: every SB camp, sorted by age',
    deck:
      'Sign-up dates, price per week, and the ones that fill in an afternoon.',
    category: 'Camps',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/447c54c0-b64c-460b-856d-112a10420c96.jpg',
    imageAlt: 'Kids in life jackets carrying paddles toward a calm harbor dock',
    updated: 'Updated June 2026',
    readMinutes: 14,
    itemCount: 63,
    ages: ['3–5', '6–9', '10+'],
    neighborhood: 'Countywide',
    cost: '$$',
    sponsored: true,
  },
  {
    slug: 'kid-friendly-restaurants-funk-zone',
    title: 'Where to eat with kids near the waterfront',
    deck:
      'Patios with room to wiggle, food that arrives fast, and exactly which ones have high chairs.',
    category: 'Eat',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9a1e9bcd-8211-4fbf-a50a-a409c415fec2.jpg',
    imageAlt:
      'A casual outdoor taco patio with a picnic table and string lights at golden hour',
    updated: 'Updated June 2026',
    readMinutes: 9,
    itemCount: 15,
    ages: ['0–2', '3–5', '6–9', '10+'],
    neighborhood: 'Funk Zone',
    cost: '$$',
  },
]
